<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M22 12a4 4 0 00-1.65-3.22A9 9 0 0012 2a8.78 8.78 0 00-8.34 6.77A4 4 0 006 16a1 1 0 001-1V9a1 1 0 00-.91-1A6.58 6.58 0 0112 4a6.76 6.76 0 015.9 4 1 1 0 00-.9 1v6a1 1 0 00.58.9 7.05 7.05 0 01-2.3 2.1A3.48 3.48 0 0012 16a3.29 3.29 0 00-3.5 3 3.29 3.29 0 003.5 3 3.57 3.57 0 003.2-1.79.65.65 0 00.19 0 9.2 9.2 0 004.77-4.76v-.06A4 4 0 0022 12zM4 12a2 2 0 01.75-1.54 1.12 1.12 0 00.25-.11v3.38A2 2 0 014 12zm8 8c-.8 0-1.5-.47-1.5-1s.7-1 1.5-1 1.5.47 1.5 1-.7 1-1.5 1zm7-9.71a2 2 0 010 3.44v-3.45z"/></svg>